<app-ilustration-with-message [illustrationName]="(data?.icon) || 'notify.svg'" [text]="data?.message || 'Unknown Error !!!'"></app-ilustration-with-message>